import { useCallback, useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import PageShell from '../components/PageShell';
import YouTubeReleaseGrid from '../components/YouTubeReleaseGrid';
import { syncRecordsByUrl } from '../services/siteContentService';
import {
  getLatestYouTubeReleases,
  YOUTUBE_RELEASES_URL
} from '../services/youtubeMusicService';

const { FiArrowUpRight, FiDisc, FiRefreshCw } = FiIcons;

export default function Music() {
  const [releases, setReleases] = useState([]);
  const [feedLoading, setFeedLoading] = useState(true);
  const [feedError, setFeedError] = useState('');

  const loadReleases = useCallback(async (force = false) => {
    setFeedLoading(true);
    setFeedError('');

    try {
      const liveReleases = await getLatestYouTubeReleases({ force });
      setReleases(liveReleases);

      const records = liveReleases.map(
        ({ video_id, published_at, description, ...release }) => ({
          ...release,
          description: published_at
            ? `Released ${new Date(published_at).toLocaleDateString()}`
            : description
        })
      );

      syncRecordsByUrl('music', records).catch(() => {});
    } catch (error) {
      setReleases([]);
      setFeedError(error.message || 'Unable to load the latest releases');
    } finally {
      setFeedLoading(false);
    }
  }, []);

  useEffect(() => {
    loadReleases();
  }, [loadReleases]);

  return (
    <PageShell>
      <section className="page-heading">
        <span className="page-icon">
          <SafeIcon icon={FiDisc} />
        </span>
        <div>
          <p className="eyebrow">Dadda Cool music</p>
          <h1>Music drops</h1>
          <p>Watch the latest full-length Dadda Cool music releases.</p>
        </div>
      </section>

      {releases.length > 0 && (
        <YouTubeReleaseGrid releases={releases} />
      )}

      {feedLoading && !releases.length && (
        <div className="empty-state">
          Loading the latest music releases...
        </div>
      )}

      {!feedLoading && feedError && (
        <div className="empty-state">
          <p>We could not load the latest music releases right now.</p>
          <button
            type="button"
            className="primary-button"
            onClick={() => loadReleases(true)}
          >
            <SafeIcon icon={FiRefreshCw} className="mr-2 h-4 w-4" />
            Try again
          </button>
        </div>
      )}

      {!feedLoading && !feedError && !releases.length && (
        <div className="empty-state">
          No full-length public music releases were found.
        </div>
      )}

      <a
        href={YOUTUBE_RELEASES_URL}
        target="_blank"
        rel="noreferrer"
        className="mt-4 flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-white/10 bg-white/[0.04] px-4 text-sm font-semibold text-slate-300 transition hover:border-cyan-300/40 hover:text-cyan-200"
      >
        <span>See all releases on YouTube</span>
        <SafeIcon icon={FiArrowUpRight} className="h-4 w-4" />
      </a>
    </PageShell>
  );
}